import React from 'react';
import LoadingIcon from './loadingState';
import Pre from './pre';
import LogButton from './logButton';

type MetricProps = {
  name: string;
  loading: boolean;
  data: unknown;
  count: number;
};

export default function Metric({ name, loading, data, count }: MetricProps) {
  return (
    <div className="flex flex-row items-center gap-1">
      <LoadingIcon loading={loading} count={count} />
      <Pre className="m-0 p-1 leading-none">
        {name}&nbsp;({count})
      </Pre>
      <LogButton name={name} data={data} />
    </div>
  );
}
